export const environment = {
  production: true,
  // apiURL: "https://api.lunch.work-trenda.at/api/",
  apiURL: "https://api.gasthofmader.itkaufmann.cloud/api/",
  url: "https://api.gasthofmader.itkaufmann.cloud/"
};
